<template>
  <img
    class="logo-gov-co-header"
    src="/img/logo-header-vectorial.svg"
    alt="Gobierno de Colombia"
  />
</template>

<script>
export default {};
</script>
<style>
.logo-gov-co-header {
  height: 26px !important;
  width: 134px !important;   
}
</style>
